import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';
import {ApiConfigService} from './api.config.service';
import {HTTP_CACHE_TTL_MS, HttpCacheService} from '../services/http-cache.service';
import {
  FamilyRelationship,
  FamilyRelationshipTypes,
  SaveFamilyRelationshipsRequest
} from '../../shared/models/family-relationships.model';

@Injectable({providedIn: 'root'})
export class FamilyRelationshipService {
  constructor(
    private http: HttpClient,
    private hoomvipStorage: HoomvipStorage,
    private apiConfigService: ApiConfigService,
    private cache: HttpCacheService) {
  }

  getFamilyRelationshipTypes() {
    const code = this.hoomvipStorage.getCode();
    const url = this.apiConfigService.getFamilyRelationshipsUrl();
    const key = `FamilyRelationshipService:GET:${url}:code=${encodeURIComponent(code ?? '')}`;
    return this.cache.getOrSet(
      key,
      HTTP_CACHE_TTL_MS.UNIMPORTANT,
      () => this.http.get<FamilyRelationshipTypes>(url)
    );
  }

  saveFamilyRelationships(familyRelationships: FamilyRelationship) {
    const code = this.hoomvipStorage.getCode();
    const url = this.apiConfigService.saveFamilyRelationshipsUrl();
    const request: SaveFamilyRelationshipsRequest = {
      code: code,
      family_relationships: [familyRelationships]
    };
    return this.http.post(url, request);
  }

}
